import AppLayout from "../layouts/AppLayout";
import Register from "../components/Register";
import HomePage from "../pages/HomePage";
import { Navigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import ChatInterface from "../pages/ChatInterface";
import ItineraryPage from "../pages/ItineraryPage";
import LoginOrRegister from "../pages/LoginOrRegister";
import LandingPage from "../pages/LandingPage";




function Logout() {
    // const queryClient = useQueryClient();

    localStorage.clear();
    // queryClient.clear();
    return <Navigate to="/login" />;
  }

function RegisterAndLogout() {
    // const queryClient = useQueryClient();

    localStorage.clear();
    // queryClient.clear();
    return <LoginOrRegister action="register" />;
  }


export interface RouteItem {
  path: string;
  element: React.JSX.Element;
  roles: string[];
  children?: Record<string, RouteItem>; // optionnal children routes
}

export const routes: Record<string, RouteItem> = {
  login: {
    path: "/login",
    element: <LoginOrRegister action="login" />,
    roles: ["guest"],  // Accessible à tous
  },
  register: {
    path: "/register",
    element: <RegisterAndLogout />,
    roles: ["guest"],  // Accessible à tous
  },
  logout: {
    path: "/logout",
    element: <Logout />,
    roles: ["guest"],  // Accessible à tous
  },
  landingpage: {
    path: "/discover_travel_ai",
    element: <LandingPage />,
    roles: ["guest"],  // Accessible à tous
  },
  // home: {
  //   path: "/home",
  //   element: <AppLayout />,
  //   roles: ["admin", "user"],  // Dashboard accessible aux admins et utilisateurs
  //   children: {
  //     root: { path: "", element: <HomePage />, roles: ["admin", "user"] },
  //   },
      
  // },
  chat: {
    path: "/chat",
    element: <AppLayout />,
    roles: ["admin", "user"],  // Dashboard accessible aux admins et utilisateurs
    children: {
      root: { path: "", element: <ChatInterface />, roles: ["admin", "user"] },
      conversation: { path: ":uuid", element: <ChatInterface />, roles: ["admin", "user"] },
    },
      
  },
  itinerary: {
    path: "/itinerary",
    element: <AppLayout />,
    roles: ["admin", "user"],  // Dashboard accessible aux admins et utilisateurs
    children: {
      root: { path: "", element: <ItineraryPage />, roles: ["admin", "user"] },
      item: { path: ":uuid", element: <ItineraryPage />, roles: ["admin", "user"] },
    },
      
  },



};




export const apiRoutes = {
  get_token: "/api/token/",
  refresh_token: "/api/token/refresh/",

  register: "/api/users/register/",

  chat: "/api/chat/",

  itinerary: "/api/generate-itinerary/",
  itinerary2: "/api/generate-itinerary2/",
  travel_arrangements: "/api/travel-arrangements/",


  search_flights: "api/search_flights/",
  search_transports: "api/search_transports/",
  multi_search_transports: "api/multi_search_transports/",
  search_carrental: "api/search_carrental/",
  search_activities: "api/search_activities/",
  redirect_booking: "api/redirect/",
  get_conversation_title: "api/get_conversation_title/",


  conversations: "api/conversations/",
  conversation_details: "api/conversations/:uuid/",
  messages: "api/messages/",
  message_details: "api/messages/:uuid/",
  itineraries: "api/itineraries/",
  itinerary_detail: "api/itineraries/:uuid/",
  itinerary_images: "api/itinerary_images/",


  autocomplete: "api/autocomplete/",

}